<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('平台分账接收方.分账接收方名称')" prop="receiverName">
                <a-input v-model="queryParam.receiverName" :maxLength="64" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.分账接收方名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('平台分账接收方.营业执照名称')" prop="licenseName">
                <a-input v-model="queryParam.licenseName" :maxLength="128" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.营业执照名称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('平台分账接收方.法人姓名')" prop="legalPersonName">
                <a-input v-model="queryParam.legalPersonName" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.法人姓名')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('平台分账接收方.收款账户卡号')" prop="acctNo">
                <a-input v-model="queryParam.acctNo" :maxLength="32" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.收款账户卡号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('平台分账接收方.分账接收方编号')" prop="receiverNo">
                <a-input v-model="queryParam.receiverNo" :maxLength="64" :placeholder="$t('通用.输入.请输入') + $t('平台分账接收方.分账接收方编号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['biz:platformledgerreceiver:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['biz:platformledgerreceiver:edit']">
          <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['biz:platformledgerreceiver:remove']">
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="operation" slot-scope="text, record">
          <a v-if="!record.receiverNo" @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['biz:platformledgerreceiver:edit']">
            <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
          </a>
          <a-divider type="vertical" v-if="!record.receiverNo" v-hasPermi="['biz:platformledgerreceiver:edit']" />
          <a v-if="!record.receiverNo" @click="handleApply(record)" v-hasPermi="['biz:platformledgerreceiver:apply']">
            <a-icon type="plus" />{{ $t('平台分账接收方.创建分账接收方') }}
          </a>
          <a-divider type="vertical" v-if="!record.receiverNo" v-hasPermi="['biz:platformledgerreceiver:remove']" />
          <a v-if="!record.receiverNo" @click="handleDelete(record)" v-hasPermi="['biz:platformledgerreceiver:remove']">
            <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
          </a>
          <!-- 已创建：查看详情后可发起"修改分账接收方"变更 -->
          <a v-if="record.receiverNo" @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['biz:platformledgerreceiver:query']">
            <a-icon type="eye" />{{ $t('平台分账接收方.详情') }}
          </a>
        </span>
        <template slot="receiverNo" slot-scope="text, record">
          {{ record.receiverNo || $t('平台分账接收方.未创建') }}
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePlatformLedgerReceiver, delPlatformLedgerReceiver, applyPlatformLedgerReceiver } from '@/api/user/platformLedgerReceiver'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PlatformLedgerReceiver',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        receiverName: undefined,
        licenseName: undefined,
        legalPersonName: undefined,
        acctNo: undefined,
        receiverNo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: this.$t('平台分账接收方.分账接收方名称'), dataIndex: 'receiverName', align: 'center' },
        { title: this.$t('平台分账接收方.营业执照名称'), dataIndex: 'licenseName', ellipsis: true, align: 'center' },
        { title: this.$t('平台分账接收方.法人姓名'), dataIndex: 'legalPersonName', align: 'center' },
        { title: this.$t('平台分账接收方.收款账户名称'), dataIndex: 'acctName', align: 'center' },
        { title: this.$t('平台分账接收方.收款账户卡号'), dataIndex: 'acctNo', ellipsis: true, align: 'center' },
        { title: this.$t('平台分账接收方.开户行名称'), dataIndex: 'acctOpenBankName', ellipsis: true, align: 'center' },
        { title: this.$t('平台分账接收方.分账接收方编号'), dataIndex: 'receiverNo', scopedSlots: { customRender: 'receiverNo' }, ellipsis: true, align: 'center' },
        { title: this.$t('通用.文本.操作'), dataIndex: 'operation', width: '20%', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      pagePlatformLedgerReceiver(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        receiverName: undefined,
        licenseName: undefined,
        legalPersonName: undefined,
        acctNo: undefined,
        receiverNo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.selectedRowKeys = []
      this.ids = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /** 创建分账接收方 */
    handleApply(record) {
      const that = this
      this.$confirm({
        title: this.$t('平台分账接收方.创建分账接收方'),
        content: this.$t('平台分账接收方.确认创建提示'),
        onOk() {
          that.submitLoading = true
          return applyPlatformLedgerReceiver({ id: record.id })
            .then(() => {
              that.$message.success(that.$t('通用.文本.操作成功'))
              that.getList()
            })
            .finally(() => {
              that.submitLoading = false
            })
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = [row.id]
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = that.ids.map((id) => id)
          return delPlatformLedgerReceiver(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'))
          })
        },
        onCancel() {
          that.ids = []
        }
      })
    }
  }
}
</script>
